import React, { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);
export const useCart = () => useContext(CartContext);

const keyOf = (i) => `${i.product_id}|${i.size || ""}`;

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("pahlawan_cart")) || [];
    } catch {
      return [];
    }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem("pahlawan_cart", JSON.stringify(items));
  }, [items]);

  const addItem = (item) => {
    setItems((prev) => {
      const k = keyOf(item);
      const existing = prev.find((p) => keyOf(p) === k);
      if (existing) {
        return prev.map((p) => (keyOf(p) === k ? { ...p, quantity: p.quantity + item.quantity } : p));
      }
      return [...prev, item];
    });
  };

  const removeItem = (k) => setItems((prev) => prev.filter((p) => keyOf(p) !== k));
  const setQty = (k, q) => setItems((prev) => prev.map((p) => (keyOf(p) === k ? { ...p, quantity: Math.max(1, q) } : p)));
  const clear = () => setItems([]);

  const count = items.reduce((n, p) => n + p.quantity, 0);
  const subtotal = items.reduce((s, p) => s + p.priceValue * p.quantity, 0);

  return (
    <CartContext.Provider value={{ items, addItem, removeItem, setQty, clear, count, subtotal, open, setOpen, keyOf }}>
      {children}
    </CartContext.Provider>
  );
};
